export const GENRE_FILTER_DICTIONARY = {
  all: { ja: "すべて", en: "All" },
  programming: { ja: "プログラミング", en: "Programming" },
  design: { ja: "デザイン", en: "Design" },
  business: { ja: "ビジネス", en: "Business" },
  language: { ja: "言語", en: "Language" },
  other: { ja: "その他", en: "Other" },
};

export const TAG_FILTER_DICTIONARY = {
  all: { ja: "すべて", en: "All" },
  effect: { ja: "エフェクト", en: "Effect" },
  mind: { ja: "マインド", en: "Mind" },
  rough: { ja: "ラフ", en: "Rough" },
  leather: { ja: "レザー", en: "Leather" },
  season: { ja: "季節", en: "Season" },
  metal: { ja: "金属", en: "Metal" },
  composition: { ja: "構図", en: "Composition" },
  finishing: { ja: "仕上げ", en: "Finishing" },
  "eye-guidance": { ja: "視線誘導", en: "Eye Guidance" },
  "reference-use": { ja: "資料の活用", en: "Reference Use" },
  hands: { ja: "手", en: "Hands" },
  female: { ja: "女性", en: "Female" },
  color: { ja: "色", en: "Color" },
  "line-art": { ja: "線画", en: "Line Art" },
  male: { ja: "男性", en: "Male" },
  eyes: { ja: "目", en: "Eyes" },
  skin: { ja: "肌", en: "Skin" },
  hair: { ja: "髪の毛", en: "Hair" },
  expression: { ja: "表情", en: "Expression" },
  cloth: { ja: "布", en: "Cloth" },
  "design-monthly": { ja: "デザイン月間", en: "Design Monthly" },
  perspective: { ja: "パース", en: "Perspective" },
  "vignette-monthly": { ja: "ビネット月間", en: "Vignette Monthly" },
  "overhead-view": { ja: "ふかん", en: "Overhead View" },
  "human-body": { ja: "人体", en: "Human Body" },
  coloring: { ja: "塗り", en: "Coloring" },
  "coloring-monthly": { ja: "塗り月間", en: "Coloring Monthly" },
  background: { ja: "背景", en: "Background" },
  "background-monthly": { ja: "背景月間", en: "Background Monthly" },
  "anime-coloring": { ja: "アニメ塗り", en: "Anime Coloring" },
  "brush-coloring": { ja: "ブラシ塗り", en: "Brush Coloring" },
  "low-angle": { ja: "あおり", en: "Low Angle" },
  "lower-body": { ja: "下半身", en: "Lower Body" },
  face: { ja: "顔", en: "Face" },
  muscles: { ja: "筋肉", en: "Muscles" },
  "monthly-critique-room": { ja: "月イチ添削室", en: "Monthly Critique Room" },
  shoulders: { ja: "肩", en: "Shoulders" },
  neck: { ja: "首", en: "Neck" },
  "upper-body": { ja: "上半身", en: "Upper Body" },
  "ground-contact": { ja: "接地面", en: "Ground Contact" },
  head: { ja: "頭", en: "Head" },
  "body-proportion": { ja: "頭身", en: "Body Proportion" },
  arms: { ja: "腕", en: "Arms" },
  outerwear: { ja: "アウター", en: "Outerwear" },
  sports: { ja: "スポーツ", en: "Sports" },
  "gesture-drawing": { ja: "ジェスドロ", en: "Gesture Drawing" },
  wrinkles: { ja: "シワ", en: "Wrinkles" },
  suit: { ja: "スーツ", en: "Suit" },
  dress: { ja: "ドレス", en: "Dress" },
  hoodie: { ja: "パーカー", en: "Hoodie" },
  "film-study": { ja: "フィルムスタディー", en: "Film Study" },
  shoes: { ja: "靴", en: "Shoes" },
  pose: { ja: "ポーズ", en: "Pose" },
  "fashion-accessories": { ja: "ファッション小物", en: "Fashion Accessories" },
  "maid-outfit": { ja: "メイド服", en: "Maid Outfit" },
  camera: { ja: "カメラ", en: "Camera" },
  weather: { ja: "天気", en: "Weather" },
  uniform: { ja: "制服", en: "Uniform" },
  sitting: { ja: "座り", en: "Sitting" },
  gesture: { ja: "仕草", en: "Gesture" },
  swimsuit: { ja: "水着", en: "Swimsuit" },
  running: { ja: "走り", en: "Running" },
  legs: { ja: "足", en: "Legs" },
  "multiple-people": { ja: "複数人", en: "Multiple People" },
  walking: { ja: "歩き", en: "Walking" },
  kimono: { ja: "和装", en: "Kimono" },
  "color-drawing": { ja: "カラーデッサン", en: "Color Drawing" },
  shirt: { ja: "シャツ", en: "Shirt" },
  skirt: { ja: "スカート", en: "Skirt" },
  drawing: { ja: "デッサン", en: "Drawing" },
  hatching: { ja: "ハッチング", en: "Hatching" },
  brush: { ja: "ブラシ", en: "Brush" },
  cylinder: { ja: "円柱", en: "Cylinder" },
  "perspective-method": { ja: "遠近法", en: "Perspective Method" },
  "natural-objects": { ja: "自然物", en: "Natural Objects" },
  sphere: { ja: "球", en: "Sphere" },
  buildings: { ja: "建物", en: "Buildings" },
  transparent: { ja: "透明", en: "Transparent" },
  box: { ja: "箱", en: "Box" },
  "complex-shapes": { ja: "複雑な形", en: "Complex Shapes" },
  "sd-character": { ja: "SDキャラクター", en: "SD Character" },
  idea: { ja: "アイデア", en: "Idea" },
  "character-design": { ja: "キャラデザ", en: "Character Design" },
  concept: { ja: "コンセプト", en: "Concept" },
  silhouette: { ja: "シルエット", en: "Silhouette" },
  detail: { ja: "ディテール", en: "Detail" },
  making: { ja: "メイキング", en: "Making" },
  mecha: { ja: "メカ", en: "Mecha" },
  elements: { ja: "要素", en: "Elements" },
  "costume-design": { ja: "衣装デザイン", en: "Costume Design" },
  anthropomorphism: { ja: "擬人化", en: "Anthropomorphism" },
  "thick-painting": { ja: "厚塗り", en: "Thick Painting" },
  "artwork-analysis": { ja: "作品分析", en: "Artwork Analysis" },
  turnaround: { ja: "三面図", en: "Turnaround" },
  monster: { ja: "モンスター", en: "Monster" },
  worldbuilding: { ja: "世界観", en: "Worldbuilding" },
  "weapon-design": { ja: "武器デザイン", en: "Weapon Design" },
  "standing-illustration": { ja: "立ち絵", en: "Standing Illustration" },
  chibi: { ja: "デフォルメ", en: "Chibi" },
  fantasy: { ja: "ファンタジー", en: "Fantasy" },
  "near-future-sf": { ja: "近未来SF", en: "Near-Future SF" },
  frills: { ja: "フリル", en: "Frills" },
  work: { ja: "仕事", en: "Work" },
  design: { ja: "デザイン", en: "Design" },
  portfolio: { ja: "ポートフォリオ", en: "Portfolio" },
  "content-creation": { ja: "コンテンツ作り", en: "Content Creation" },
  radio: { ja: "ラジオ", en: "Radio" },
  consultation: { ja: "お悩み相談", en: "Consultation" },
  "career-consultation": { ja: "進路相談", en: "Career Consultation" },
  basics: { ja: "基礎", en: "Basics" },
  intermediate: { ja: "中級", en: "Intermediate" },
  advanced: { ja: "上級", en: "Advanced" },
  practice: { ja: "実践", en: "Practice" },
  critique: { ja: "添削", en: "Critique" },
  lighting: { ja: "ライティング", en: "Lighting" },
  illustration: { ja: "イラスト", en: "Illustration" },
  "required-subject": { ja: "必須科目", en: "Required Subject" },
  dojo: { ja: "道場", en: "Dojo" },
  movement: { ja: "動き", en: "Movement" },
  pants: { ja: "ズボン", en: "Pants" },
  value: { ja: "バリュー", en: "Value" },
  "character-setting": { ja: "キャラ設定", en: "Character Setting" },
};

export const TAG_FILTER_GROUPS = [
  {
    id: "learning",
    label: { ja: "目的・学習タイプ", en: "Purpose / Level" },
    tags: [
      "required-subject", // 必須科目
      "basics", // 基礎
      "intermediate", // 中級
      "advanced", // 上級
      "practice", // 実践
      "critique", // 添削
      "dojo", // 道場
      "mind", // マインド
      "making", // メイキング
      "reference-use", // 資料の活用
      "film-study", // フィルムスタディー
      "artwork-analysis", // 作品分析
    ],
  },
  {
    id: "body",
    label: { ja: "人体・顔", en: "Body / Face" },
    tags: [
      "human-body", // 人体
      "body-proportion", // 頭身
      "head", // 頭
      "face", // 顔
      "eyes", // 目
      "expression", // 表情
      "neck", // 首
      "shoulders", // 肩
      "upper-body", // 上半身
      "lower-body", // 下半身
      "hands", // 手
      "arms", // 腕
      "legs", // 足
      "muscles", // 筋肉
      "skin", // 肌
      "hair", // 髪の毛
      "male", // 男性
      "female", // 女性
    ],
  },
  {
    id: "pose",
    label: { ja: "ポーズ・構図", en: "Pose / Composition" },
    tags: [
      "rough", // ラフ
      "composition", // 構図
      "pose", // ポーズ
      "gesture", // 仕草
      "gesture-drawing", // ジェスドロ
      "movement", // 動き
      "sitting", // 座り
      "walking", // 歩き
      "running", // 走り
      "multiple-people", // 複数人
      "perspective", // パース
      "overhead-view", // ふかん
      "low-angle", // あおり
      "eye-guidance", // 視線誘導
      "ground-contact", // 接地面
    ],
  },
  {
    id: "clothing",
    label: { ja: "服・小物", en: "Clothing / Accessories" },
    tags: [
      "cloth", // 布
      "wrinkles", // シワ
      "outerwear", // アウター
      "shirt", // シャツ
      "skirt", // スカート
      "pants", // ズボン
      "suit", // スーツ
      "dress", // ドレス
      "hoodie", // パーカー
      "uniform", // 制服
      "swimsuit", // 水着
      "kimono", // 和装
      "maid-outfit", // メイド服
      "shoes", // 靴
      "fashion-accessories", // ファッション小物
      "frills", // フリル
      "sports", // スポーツ
    ],
  },
  {
    id: "coloring",
    label: { ja: "線画・塗り・仕上げ", en: "Line / Coloring / Finish" },
    tags: [
      "line-art", // 線画
      "color", // 色
      "coloring", // 塗り
      "anime-coloring", // アニメ塗り
      "brush-coloring", // ブラシ塗り
      "thick-painting", // 厚塗り
      "color-drawing", // カラーデッサン
      "brush", // ブラシ
      "value", // バリュー
      "lighting", // ライティング
      "effect", // エフェクト
      "finishing", // 仕上げ
    ],
  },
  {
    id: "background",
    label: { ja: "背景・デッサン", en: "Background / Drawing" },
    tags: [
      "background", // 背景
      "drawing", // デッサン
      "hatching", // ハッチング
      "perspective-method", // 遠近法
      "cylinder", // 円柱
      "sphere", // 球
      "box", // 箱
      "complex-shapes", // 複雑な形
      "natural-objects", // 自然物
      "buildings", // 建物
      "transparent", // 透明
    ],
  },
  {
    id: "design",
    label: { ja: "デザイン・世界観", en: "Design / Worldbuilding" },
    tags: [
      "illustration", // イラスト
      "design", // デザイン
      "character-design", // キャラデザ
      "character-setting", // キャラ設定
      "costume-design", // 衣装デザイン
      "idea", // アイデア
      "concept", // コンセプト
      "silhouette", // シルエット
      "detail", // ディテール
      "elements", // 要素
      "mecha", // メカ
      "monster", // モンスター
      "anthropomorphism", // 擬人化
      "turnaround", // 三面図
      "worldbuilding", // 世界観
      "weapon-design", // 武器デザイン
      "standing-illustration", // 立ち絵
      "sd-character", // SDキャラクター
      "chibi", // デフォルメ
      "fantasy", // ファンタジー
      "near-future-sf", // 近未来SF
    ],
  },
  {
    id: "materials",
    label: { ja: "素材・モチーフ", en: "Materials / Motifs" },
    tags: [
      "leather", // レザー
      "metal", // 金属
      "season", // 季節
      "camera", // カメラ
      "weather", // 天気
    ],
  },
  {
    id: "monthly",
    label: { ja: "月間・企画", en: "Monthly / Specials" },
    tags: [
      "design-monthly", // デザイン月間
      "vignette-monthly", // ビネット月間
      "coloring-monthly", // 塗り月間
      "background-monthly", // 背景月間
      "monthly-critique-room", // 月イチ添削室
    ],
  },
  {
    id: "career",
    label: { ja: "仕事・相談", en: "Career / Consultation" },
    tags: [
      "work", // 仕事
      "portfolio", // ポートフォリオ
      "content-creation", // コンテンツ作り
      "radio", // ラジオ
      "consultation", // お悩み相談
      "career-consultation", // 進路相談
    ],
  },
];

/**
 * 「シリーズ」表示枠で category_id を使うための辞書。
 * 必要に応じて categories テーブルの id と表示名を追加していく。
 * 表示順は SERIES_FILTER_ORDER を編集すること（数値キーは Object.keys でも ID 順になる）。
 */
export const SERIES_FILTER_DICTIONARY = {
  all: { ja: "すべて", en: "All" },
  1: { ja: "イラスト基礎", en: "Illustration Basics" },
  2: { ja: "人体基礎", en: "Human Basics" },
  3: { ja: "デッサン", en: "Drawing" },
  4: { ja: "キャラデザ", en: "Character Design" },
  5: { ja: "ジェスドロ", en: "Gesture Drawing" },
  10: { ja: "フィルムスタディ", en: "film study" },
  7: { ja: "集中月間", en: "Monthly Intensive" },
  8: { ja: "特別授業", en: "Special Lesson" },
  9: { ja: "Bar校長", en: "Bar Principal" },
  11: { ja: "10期生基礎授業", en: "10th class" },
};

/** 講座ページのカテゴリ一覧の表示順（SERIES_FILTER_DICTIONARY のキー） */
export const SERIES_FILTER_ORDER = [
  "all",
  "1",
  "2",
  "3",
  "4",
  "5",
  "10",
  "7",
  "8",
  "9",
  "11",
];

/** 講座ページのカテゴリ一覧から隠す category_id（動画の直リンク視聴自体は可能） */
export const SERIES_FILTER_HIDDEN = new Set(["11"]);

export const SORT_OPTIONS = [
  { value: "newest", labelKey: "newest" },
  { value: "oldest", labelKey: "oldest" },
];

export function getDictionaryLabel(dictionary, key, language, fallback) {
  const entry = dictionary[String(key)];
  if (!entry) return fallback ?? String(key);
  return language === "en" ? entry.en : entry.ja;
}
